import {ErrorBoundary} from "@/components/ErrorBoundary";
import {AppProviders} from "./AppProviders";
import {AppRoutes} from "./AppRoutes";

export function App() {
    return (
        <ErrorBoundary>
            <AppProviders>
                <AppRoutes />
            </AppProviders>
        </ErrorBoundary>
    );
}
